import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=55c2454d&"
import script from "./DocumentPreview.js?vue&type=script&lang=js&"
export * from "./DocumentPreview.js?vue&type=script&lang=js&"
import style0 from "./DocumentPreview.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports